import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import StyledPrimaryLoadingButton from 'common/theme/button/StyledPrimaryLoadingButton';

function PrimaryLoadingButton({ loading, onClick = () => {}, label, ...rest }) {
  return (
    <StyledPrimaryLoadingButton
      {...rest}
      size="small"
      onClick={onClick}
      loading={loading}
      loadingIndicator={<CircularProgress color="inherit" size={16} />}
      variant="contained">
      <span>{label}</span>
    </StyledPrimaryLoadingButton>
  );
}

PrimaryLoadingButton.propTypes = {
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

export default PrimaryLoadingButton;
